import api from "@axios";

export default {
  namespaced: true,

  state: () => ({
    assest: {},
    loading: false,
  }),
  getters: {
    assest(state) {
      return state.assest;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setAssest(state, payload) {
      state.assest = payload;
    },
  },
  actions: {
    getAssestPage({ commit }, endpoint) {
      commit("setLoading", true);
      api
        .get(endpoint)
        .then((res) => {
          commit("setAssest", res.data.data);
          commit("setLoading", false);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    },
  },
};
